import Modal from '@berlitzplatforms/micro.ui.modal'
import BlockScheduling from '@components/BlockScheduling'
import { CenterText } from '@components/Modal/style'
import * as React from 'react'

interface BlockSchedulingModalProps {
  open: boolean
  onClose: Function
  onProceed?: Function
}

const BlockSchedulingModal: React.FC<BlockSchedulingModalProps> = ({ open, onClose, onProceed }) => (
  <Modal open={open} onClose={onClose}>
    <CenterText>
      <BlockScheduling onProceed={onProceed} />
    </CenterText>
  </Modal>
)

export default BlockSchedulingModal
